import { useState } from 'react'
import { weddingVideos } from '../content/siteContent'
import { useExternalMedia } from './externalMediaContext'

const waveformBars = [24, 42, 68, 38, 76, 54, 92, 62, 44, 84, 58, 100, 72, 46, 88, 60, 78, 48, 94, 56, 70, 36, 64, 40, 26]

export function VideoGallery() {
  const { allowed, allow } = useExternalMedia()
  const [activeVideo, setActiveVideo] = useState<string | null>(null)

  function playVideo(id: string) {
    if (!allowed) allow()
    setActiveVideo(id)
  }

  return (
    <div className="video-grid">
      {weddingVideos.map((video, index) => (
        <article className="video-card" key={video.id}>
          {activeVideo === video.id && allowed ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1`}
              title={`${video.title} — Kasia Staszewska`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button type="button" className="video-card__poster" onClick={() => playVideo(video.id)} aria-label={`Odtwórz: ${video.title}`}>
              <span className="video-card__number">{String(index + 1).padStart(2, '0')}</span>
              <span className="video-card__waveform" aria-hidden="true">{waveformBars.map((height, barIndex) => <i key={`${video.id}-${barIndex}`} style={{ height: `${height}%` }} />)}</span>
              <span className="video-card__play" aria-hidden="true">▶</span>
              <span className="video-card__consent">{allowed ? 'Odtwórz nagranie' : 'Zezwól na YouTube i odtwórz'}</span>
            </button>
          )}
          <h3>{video.title}</h3>
        </article>
      ))}
    </div>
  )
}
